export var SITECODES = {
  OLXID: 'olxid',
  OLXTR: 'olxtr',
  OLXPL: 'olxpl'
};